import React from "react";

export default function AAHistory() {
  return (
    <section className="py-12 px-6 lg:px-20 bg-white text-gray-800 leading-relaxed text-justify">
      <div className="max-w-5xl mx-auto">
        <h1 className="text-3xl font-bold mb-6 text-center text-blue-700">
          AAவின் தொடக்கமும் வளர்ச்சியும்
        </h1>

        <p className="mb-4">
          AAவின் வரலாறு அமெரிக்காவில் தொடங்கி, கனடாவுக்குப் பரவி, பின்னர் உலகம் முழுவதும் பரவியது.
          AA இப்போது 180 க்கும் மேற்பட்ட நாடுகளில் உள்ளது. AAவின் தொடக்கம் மற்றும் அதன் சில முக்கிய
          பங்களிப்பாளர்கள் பற்றிய ஒரு சிறு வரலாறு பின்வருமாறு.
        </p>

        <h2 className="text-2xl font-semibold mt-8 mb-3 text-blue-600">AAவின் தொடக்கம்</h2>
        <p className="mb-4">
          1935 ஆம் ஆண்டு, நியூயார்க் பங்கு தரகரான பில் டபிள்யூ. மற்றும் அக்ரான் அறுவை சிகிச்சை
          நிபுணரான டாக்டர் பாப் எஸ். ஆகியோருக்கு இடையேயான சந்திப்பின் விளைவாக, ஓஹியோவின் அக்ரோனில்
          AA தொடங்கியது. இருவரும் நம்பிக்கையற்ற குடிகாரர்கள்.
        </p>
        <p className="mb-4">
          சந்திப்பதற்கு முன்பு, பில் மற்றும் டாக்டர் பாப் இருவரும் ஆக்ஸ்போர்டு குழுமத்துடன் தொடர்பில்
          இருந்தனர். பெரும்பாலும் மது அருந்தாத இந்த கூட்டுறவு, அன்றாட வாழ்வில் உலகளாவிய ஆன்மீக
          விழுமியங்களை வலியுறுத்தியது. அந்த நேரத்தில் எபிஸ்கோபல் மதகுரு டாக்டர் சாமுவேல் ஷூமேக்கர்
          அமெரிக்காவில் ஆக்ஸ்போர்டு குழுக்களுக்கு தலைமை தாங்கினார்.
        </p>
        <p className="mb-4">
          இந்த ஆன்மீக செல்வாக்கின் கீழும், பழைய கால நண்பரான எப்பி டி.யின் உதவியுடனும், பில்
          நிதானமாகிவிட்டார். பில் மற்ற குடிகாரர்களுடன் இணைந்து பணியாற்றுவதன் மூலம் தனது
          மீட்சியைப் பராமரித்தார். இருப்பினும், டாக்டர் பாப்பைச் சந்திப்பதற்கு முன்பு, இந்த மற்ற
          குடிகாரர்கள் யாரும் உண்மையில் குணமடையவில்லை.
        </p>
        <p className="mb-4">
          அதே நேரத்தில், அக்ரானில் டாக்டர் பாப் ஆக்ஸ்போர்டு குழுவில் உறுப்பினராக இருந்தது அவருக்கு
          நிதானத்தை அடைய போதுமான அளவு உதவவில்லை. டாக்டர் பாப் மற்றும் பில் இறுதியாக சந்தித்தபோது,
          அதன் விளைவு மருத்துவரிடம் உடனடியாக இருந்தது. இந்த முறை, அவர் வெற்றி பெற்று வந்த சக
          நோயாளியை நேருக்கு நேர் சந்தித்தார்.
        </p>
        <p className="mb-4">
          குடிப்பழக்கம் என்பது மனம், உணர்ச்சிகள் மற்றும் உடலின் ஒரு நோய் என்று பில் வலியுறுத்தினார்.
          நியூயார்க்கில் உள்ள டவுன்ஸ் மருத்துவமனையின் டாக்டர் வில்லியம் டி. சில்க்வொர்த்திடமிருந்து பில்
          இந்த முக்கியமான உண்மையைக் கற்றுக்கொண்டார். பில் பெரும்பாலும் டாக்டர் சில்க்வொர்த்தின் நேரடி
          நோயாளியாக இருந்தார். ஒரு மருத்துவராக இருந்தபோதிலும், டாக்டர் பாப் குடிப்பழக்கம் ஒரு நோயென்று
          அறிந்திருக்கவில்லை. பில்லின் உறுதியான யோசனைகளுக்கு பதிலளித்த டாக்டர் பாப் விரைவில்
          நிதானமானார், மீண்டும் ஒருபோதும் குடிக்கவில்லை. இது AA ஒரு அமைப்பாக உருவாக்க தூண்டியது.
        </p>
        <p className="mb-4">
          இருவரும் உடனடியாக அக்ரோனின் நகர மருத்துவமனையில் குடிகாரர்களுடன் வேலை செய்யத் தொடங்கினர்.
          ஒரு நோயாளி விரைவில் முழுமையான நிதானத்தை அடைந்தார். இந்த மூன்று ஆண்களும் முதல் AA
          குழுவின் மையக்கருவை உருவாக்கினர் (ஆல்கஹாலிக்ஸ் அனானிமஸ் என்ற பெயர் இன்னும் பயன்படுத்தப்படவில்லை
          என்றாலும்).
        </p>

        <h2 className="text-2xl font-semibold mt-8 mb-3 text-blue-600">
          வளர்ச்சி மெதுவாகத் தொடங்கி, பின்னர் விரைவாக விரிவடைந்தது
        </h2>
        <p className="mb-4">
          1935 இலையுதிர்காலத்தில், நியூயார்க்கில் இரண்டாவது குடிகாரர்கள் குழு மெதுவாக வடிவம் பெற்றது.
          மூன்றாவது குழு 1939 இல் கிளீவ்லேண்டில் தோன்றியது. மூன்று குழுக்களிலும் சுமார் 100 நிதானமான
          குடிகாரர்களை உருவாக்க நான்கு ஆண்டுகள் ஆனது.
        </p>
        <p className="mb-4">
          1939 ஆம் ஆண்டின் தொடக்கத்தில், பெல்லோஷிப் அதன் அடிப்படை பாடப்புத்தகமான "ஆல்கஹாலிக்ஸ்
          அனானிமஸ்" ஐ வெளியிட்டது. பில் எழுதிய இந்த உரை, ஆரம்பகால உறுப்பினர்கள் பலரால் மதிப்பாய்வு
          செய்யப்பட்டது, AAவின் தத்துவம் மற்றும் முறைகளை விளக்கியது. இந்த வேலையின் மையக்கரு இப்போது
          "பன்னிரண்டு வழிமுறைகளால் நலமடைதல்" என்று நன்கு அறியப்படுகிறது.
        </p>
        <p className="mb-4">
          மேலும் 1939 ஆம் ஆண்டில், தி கிளீவ்லேண்ட் ப்ளைன் டீலர் AA பற்றிய தொடர் கட்டுரைகளை
          வெளியிட்டது. இந்தக் கட்டுரைகள் கிளீவ்லேண்டில் உதவி கோரி பல வேண்டுகோள்களைத் தூண்டின. இருபது
          உறுப்பினர்களை மட்டுமே கொண்ட கிளீவ்லேண்ட் குழு, அந்த குடிகாரர்களுக்கு உதவ முயன்றது.
        </p>
        <p className="mb-4">
          1938 ஆம் ஆண்டு நியூயார்க்கில், டாக்டர் பாப் மற்றும் பில் ஆகியோர் வளர்ந்து வரும் பெல்லோஷிப்பிற்கான
          அறங்காவலர் குழுவை ஏற்பாடு செய்தனர். அறக்கட்டளை நியூயார்க்கில் ஒரு சிறிய அலுவலகத்தைத் திறக்க
          முடிந்தது. இது விசாரணைகளைக் கையாள்வதையும் AA புத்தகத்தை விநியோகிப்பதையும் நோக்கமாகக்
          கொண்டிருந்தது. இன்றுவரை, இந்த முயற்சிகளுக்கு பெரும்பாலும் AAக்களே நிதியளித்து வந்தன.
        </p>
        <p className="mb-4">
          1941ல் தி சாட்டர்டே ஈவினிங் போஸ்ட் பத்திரிகையில் ஜாக் அலெக்சாண்டர் எழுதிய கட்டுரை வெளியிடப்பட்டது.
          அதற்கு மிகப்பெரிய வரவேற்பு கிடைத்தது. ஆண்டின் இறுதியில் உறுப்பினர் எண்ணிக்கை 6,000 ஆக உயர்ந்தது.
          பெல்லோஷிப் அமெரிக்கா மற்றும் கனடா முழுவதும் பரவியது.
        </p>
        <p className="mb-4">
          1950 வாக்கில், உலகம் முழுவதும் 100,000 குடிகாரர்கள் மீட்கப்பட்டனர். இது அற்புதமாக இருந்தாலும்,
          1940-1950 காலகட்டம் பெரும் நிச்சயமற்றதாக இருந்தது. குழுக்கள் ஒன்றாக இருந்து திறம்பட செயல்பட
          முடியுமா என்பதுதான் முக்கியமான கேள்வி. 1946 வாக்கில், AAவின் நோக்கத்திற்கு பொருத்தமான கொள்கைகள்
          உருவாக்கப்பட்டன — பில் எழுதிய “மது அருந்துபவர்களின் பன்னிரண்டு கோட்பாடுகள்” என்ற புத்தகத்தில்
          அவை விளக்கப்பட்டன.
        </p>

        <h2 className="text-2xl font-semibold mt-8 mb-3 text-blue-600">
          ஓஹியோவில் இணை நிறுவனர் டாக்டர் பாபின் முக்கிய தாக்கம்
        </h2>
        <p className="mb-4">
          டாக்டர் பாப் குடிகாரர்களுக்கான மருத்துவமனை பராமரிப்புக்காக தன்னை அர்ப்பணித்தார். செயிண்ட் தாமஸ்
          மருத்துவமனையில் சுமார் 5,000 நோயாளிகளுக்கு அவர் AA கொள்கைகளை அறிமுகப்படுத்தினார். 1950 இல் அவர்
          இறந்த பின்னர், சகோதரி இக்னேஷியா கிளீவ்லேண்டில் தொடர்ந்து பணியாற்றினார்.
        </p>
        <p className="mb-4">
          அதே ஆண்டில், AA தனது முதல் சர்வதேச மாநாட்டை கிளீவ்லேண்டில் நடத்தியது. அங்கு டாக்டர் பாப்
          கடைசியாக தோன்றி “AA-வை எளிமையாக வைத்திருக்க வேண்டும்” என்ற தனது இறுதி உரையை வழங்கினார்.
        </p>

        <h2 className="text-2xl font-semibold mt-8 mb-3 text-blue-600">
          பொது சேவை மாநாட்டின் உருவாக்கம்
        </h2>
        <p className="mb-4">
          நியூயார்க் அலுவலகம் அதன் செயல்பாடுகளை விரிவுபடுத்தி, மக்கள் தொடர்பு, மருத்துவமனைகள், சிறைச்சாலைகள்
          போன்ற துறைகளில் பணியாற்றியது. 1951 இல் AA பொது சேவை மாநாடு உருவாக்கப்பட்டது, இதன் மூலம் AA-வின்
          நிரந்தர நிர்வாகம் உறுதி செய்யப்பட்டது.
        </p>
        <p className="mb-4">
          1955 இல் செயிண்ட் லூயிஸில் நடைபெற்ற இரண்டாவது சர்வதேச மாநாட்டில், பில் AAவின் பராமரிப்பை மாநாட்டிற்கும்
          அறங்காவலர்களுக்கும் ஒப்படைத்தார் — இது AA தனது “வயது வந்த” கட்டத்தை அடைந்தது எனக் கருதப்பட்டது.
        </p>

        <h2 className="text-2xl font-semibold mt-8 mb-3 text-blue-600">
          உலகளவில் AA அதன் வளர்ச்சியைத் தொடர்கிறது
        </h2>
        <p className="mb-4">
          1971 இல் பில் மியாமி கடற்கரையில் இறந்தார். அவரது கடைசி வார்த்தைகள்: “கடவுள் உங்களையும் மது அருந்துபவர்களையும்
          என்றென்றும் ஆசீர்வதிப்பாராக.” அதன் பிறகு, AA உண்மையில் உலகளாவிய அமைப்பாக வளர்ந்தது. இன்று, உலகளவில்
          சுமார் 180 நாடுகளில் AA தோழமை இயக்கமாக உருவாகி உள்ளது.
        </p>
      </div>
    </section>
  );
}
